<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('set_new_password') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form class="py-12 px-2">
            <ValidationProvider v-slot="{ errors, valid }" name="password" rules="required|min:8">
              <v-text-field v-model="form.new_password" :type="visibility ? 'text' : 'password'" :label="$t('password')" color="primary" :error-messages="errors" :append-icon="visibility ? 'mdi-eye' : 'mdi-eye-off'" autocomplete="on" @click:append="visibility = !visibility" />
            </ValidationProvider>
            <v-btn color="primary" x-large block class="text-none" @click="setNewPassword()">
              {{ $t('next') }}
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  changePassAuth as changePassAuthCustomer
} from '@/api/auth'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      visibility: false,
      password: 'Password',
      form: {
        new_password: '',
        otp_code: '',
        phone: ''
      },
      data_verification: {}
    }
  },
  created() {
    if (!this.$store.state.otp_forget_password) {
      this.$router.push({ name: 'forget_password' }).catch(() => {})
    } else {
      this.form.otp_code = this.$store.state.otp_forget_password
    }
    if (this.$store.state.data_verification) {
      this.data_verification = this.$store.state.data_verification
    } else {
      this.$router.push({ name: 'forget_password' }).catch(() => {})
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async setNewPassword() {
      try {
        this.form.phone = this.data_verification.value.phone
        await changePassAuthCustomer(this.form)
        this.$store.state.loading_axios = false
        this.$store.dispatch('remove_data_verification')
        this.$store.dispatch('remove_type_Verification')
        this.$store.dispatch('remove_otp_forget_password')
        this.$store.dispatch('fetchToken')
        this.$router.push({ name: 'login' }).catch(() => {})
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
